// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Drawer_drawer__PPd_x"};